import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { MaintenanceBanner } from './MaintenanceBanner';
import { CookieBanner } from './CookieBanner';
import { useAuth0 } from '@auth0/auth0-react';
const BottomBanners = () => {
  const $ = _c(5);
  const {
    isAuthenticated
  } = useAuth0();
  let t0;
  if ($[0] !== isAuthenticated) {
    t0 = isAuthenticated ? <MaintenanceBanner /> : null;
    $[0] = isAuthenticated;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box sx={{
      zIndex: 9999,
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      m: 1
    }}><CookieBanner /></Box>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <>{t0}{t1}</>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default BottomBanners;